<template>
    <div class="section">
        <div class="menu">
        <ul class="menu-list">
            <p class="menu-label">
                Info
            </p>
            <li><a :href="company">Empresa</a></li>
            <li><a :href="profileEndpoint">Mi perfil</a></li>
            <li><a :href="inboxPanel">Mensajes</a></li>
        </ul>
        <ul class="menu-list">
            <p class="menu-label m-t-10">
                Branding
            </p>
            <li><a :href="cmsBasic">Estilos base</a></li>
            <li><a :href="cmsPanel">Componentes</a></li>
        </ul>
        <ul v-if="isStore==='True' || isB2b ==='True'" class="menu-list">
            <p class="menu-label  m-t-10">Ecommerce</p>
            <li><a :href="catalogueUrl">Catalogo</a></li>
            <li><a :href="orderPanel">Ventas</a></li>
        </ul>
        <ul class="menu-list">
            <p class="menu-label m-t-10">Contenidos</p>
            <li><a :href="faqs">FAQs</a></li>
            <li v-if="hasBlog == 'True'"><a :href="blog">Blog</a></li>
            <li v-if="isFullSite=='True'"><a :href="customPagesUrl">Paginas</a></li>
        </ul>
        <ul v-if="isContent==='True'" class="menu-list p-t-20">
            <p class="menu-label ` m-t-10">Content Channel</p>
            <li><a href="">Subscriptions plans</a></li>
            <li><a href="">Subscribers</a></li>
            <li><a href="">Shows</a></li>
            <li><a href="">Blog</a></li>       
        </ul>
    </div>    
    </div>
</template>

<script>
export default {
    name:"Sidenav",
    props: {
        catalogueUrl:{
            type:String,
            default:""
        },
        inventoryUrl:{
            type:String,
            default:""
        },
        isStore:{
            type:String,
            default:""
        },
        isContent:{
            type:String,
            default:""
        },
        company:{
            type:String,
            default:""
        },
        profileEndpoint:{
            type:String,
            default:""
        },
        cmsBasic:{
            type:String,
            default:""
        },
        cmsPanel:{
            type:String,
            default:""
        },
        orderPanel:{
            type:String,
            default:""
        },
        inboxPanel:{
            type:String,
            default:""
        },
        isB2b:{
            type:String,
            default:""
        },
        faqs:{
            type:String,
            default:""
        },
        blog:{
            type:String,
            default:""
        },
        hasBlog:{
            type:String,
            default:""
        },
        customPagesUrl:{
            type:String,
            default:''
        },
        isFullSite:{
            type:String,
            default:""
        }
    }

}
</script>

<style lang="scss" scoped>
  @import "./../../../scss/main.scss";
</style>